<template>
  <div class="new-guest is-flex gap-32 is-flex-direction-column">
    <div class="columns mb-0 item-guests">
      <div class="column is-one-third-tablet is-two-fifths-desktop">
        <div class="field">
          <div class="control" autocomplete="off">
            <label :for="'input-name-' + orderIndex" class="label">
              Nome {{ orderIndex + 1 }}:
            </label>
            <input
              :id="'input-name-' + orderIndex"
              :ref="'input-name-' + orderIndex"
              class="input has-value outlined-field"
              type="text"
              maxlength="50"
              v-model="guestData.name"
              @input="() => update('input-name-' + orderIndex)"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control" autocomplete="off">
            <label
              :for="'select-age-' + orderIndex"
              :class="{ disabled: !guestData.name }"
              class="label"
            >
              Grupo de idade:
            </label>
            <b-select
              :id="'select-age-' + orderIndex"
              :ref="'select-age-' + orderIndex"
              v-model="guestData.type"
              class="control input has-value outlined-field guest-select"
              placeholder="Selecionar"
              :class="{ disabled: !guestData.name }"
              :disabled="!guestData.name"
              @input="update('select-age-' + orderIndex)"
            >
              <option
                class="select-items"
                v-for="(age, index) in agesList"
                :key="age.text + index"
                :value="age.value"
              >
                {{ age.text }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <div class="control" autocomplete="off">
            <label
              :for="'select-confirmed-' + orderIndex"
              :class="{ disabled: !guestData.name }"
              class="label"
            >
              Status de confirmação:
            </label>
            <b-select
              :id="'select-confirmed-' + orderIndex"
              :ref="'select-confirmed-' + orderIndex"
              v-model="guestData.confirmed"
              class="control input has-value outlined-field guest-select"
              placeholder="Selecionar"
              :class="{ disabled: !guestData.name }"
              :disabled="!guestData.name"
              @input="update('select-confirmed-' + orderIndex)"
            >
              <option
                class="select-items"
                v-for="(status, index) in statusList"
                :key="status.text + index"
                :value="status.value"
              >
                {{ status.text }}
              </option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <button
          :disabled="totalGuests === 1"
          @click="$emit('delete', orderIndex)"
          class="delete-guest"
        >
          <base-icon
            class="icon"
            width="24px"
            height="24px"
            name="painel/trash-icon"
          />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    orderIndex: {
      type: Number,
      default: 1,
    },
    totalGuests: {
      type: Number,
      default: 1,
    },
    guest: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      guestData: {},
      agesList: [
        { value: 'adult', text: 'Adulto' },
        { value: 'child', text: 'Criança' },
      ],
      statusList: [
        { value: 'maybe', text: 'Pendente confirmação' },
        { value: 'yes', text: 'Irá comparecer' },
        { value: 'no', text: 'Não irá comparecer' },
      ],
    }
  },

  computed: {
    ...mapGetters({
      rsvpConfigs: 'getRsvpConfigs',
    }),
  },

  created() {
    this.guestData = { ...this.guest }
  },

  methods: {
    ...mapActions({
      fetchRsvpConfigs: 'fetchRsvpConfigs',
    }),

    update(elementToFocus) {
      if (!this.guestData.name) {
        this.guestData.type = undefined
        this.guestData.confirmed = 'maybe'
      }

      this.$emit(
        'change',
        {
          name: this.guestData.name,
          type: this.guestData.type,
          confirmed: this.guestData.confirmed,
        },
        this.orderIndex,
        elementToFocus
      )
    },
  },
}
</script>
<style scoped lang="scss">
.guest-select {
  padding-right: 8px !important;
  ::v-deep span {
    width: 100%;
  }
  &.disabled {
    background-color: hsl(0, 0%, 96%);
  }
  select {
    height: 2.5em;
  }
}

.new-guest {
  .item-guests {
    @media (max-width: $tablet) {
      padding: 16px;
      border-radius: 8px;
      border: 1px solid #d9e2eb;
      display: flex;
      gap: 16px;
      margin: 0;
      flex-direction: column;
      div:last-child {
        order: -1;
        align-self: end;
      }
    }
    @media (min-width: $tablet) {
      align-items: flex-end;
    }
  }
  .delete-guest {
    cursor: pointer;
    border-radius: 8px;
    border: 1px solid #dde7f1;
    background: $neutrallightest;
    color: $neutral;
    display: flex;
    min-width: 56px;
    min-height: 56px;
    padding: 8px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    &:hover {
      border: 1px solid $neutrallight;
      background: #d9e2eb;
    }
    &:disabled {
      cursor: initial;
      background: #d9e2eb;
      opacity: 0.7;
      border: 1px solid $neutrallight;
    }
  }
}
</style>
